import { ReactComponent as FollowFill } from 'assets/icons/icon-follow-fill.svg';

export default FollowFill;
